<div class="entries" data-testid="dictionary-entries">
  <div class="entries__toolbar">
    <app-search
      class="entries__search"
      size="small"
      placeholder="Buscar conta, exemplo ou regra"
      [realTime]="true"
      [ngModel]="query()"
      (ngModelChange)="query.set($event ?? '')"
      data-testid="dictionary-entries-search" />
    <div class="entries__segmented" role="group" aria-label="Demonstrativo">
      @for (option of statementFilters; track option.label) {
        <button
          type="button"
          class="entries__segment"
          [class.entries__segment--active]="statementFilter() === option.value"
          [attr.aria-pressed]="statementFilter() === option.value"
          [attr.data-testid]="'dictionary-entries-filter-' + (option.value ?? 'all')"
          (click)="setStatementFilter(option.value)">
          {{ option.label }}
        </button>
      }
    </div>
    <span class="entries__count">
      {{ filtered().length }} {{ filtered().length === 1 ? 'verbete' : 'verbetes' }}
      @if (versionNumber()) {
        · versão {{ versionNumber() }}
      }
    </span>
  </div>

  @if (filtered().length === 0) {
    <div class="entries__empty">
      @if (entries().length === 0) {
        <p>O dicionário ainda não tem verbetes nesta versão.</p>
      } @else {
        <p>Nenhum verbete encontrado com esse filtro.</p>
        <app-button
          [label]="'Limpar filtros'"
          [theme]="'white'"
          [type]="'button'"
          (sendButtonClick)="clearFilters()" />
      }
    </div>
  } @else {
    @for (group of groups(); track group.key) {
      <section class="entries__group">
        <h5 class="entries__group-title">
          <span>{{ group.title }}</span>
          @if (!statementFilter()) {
            <span class="entries__group-statement">{{
              statementTypeLabel(group.statementType)
            }}</span>
          }
        </h5>
        @for (entry of group.entries; track entryKey(entry)) {
          @let open = expandedKey() === entryKey(entry);
          <article class="entry" [class.entry--open]="open" data-testid="dictionary-entry-card">
            <button
              type="button"
              class="entry__summary"
              [attr.aria-expanded]="open"
              data-testid="dictionary-entry-toggle"
              (click)="toggle(entry)">
              <span class="entry__titles">
                <span class="entry__label">{{ entry.label }}</span>
                @if (entry.definition) {
                  <span class="entry__preview">{{ entry.definition }}</span>
                }
              </span>
              <i
                class="pi"
                [class.pi-chevron-down]="!open"
                [class.pi-chevron-up]="open"
                aria-hidden="true"></i>
            </button>

            @if (open) {
              <div class="entry__detail" data-testid="dictionary-entry-detail">
                @if (entry.path) {
                  <p class="entry__path">{{ entry.path }}</p>
                }

                <div class="entry__block">
                  <span class="entry__block-title">Definição</span>
                  <p>{{ entry.definition || 'Sem definição.' }}</p>
                </div>

                @if (entry.includes.length > 0) {
                  <div class="entry__block">
                    <span class="entry__block-title">Entra</span>
                    <ul>
                      @for (include of entry.includes; track $index) {
                        <li>{{ include }}</li>
                      }
                    </ul>
                  </div>
                }

                @if (entry.excludes.length > 0) {
                  <div class="entry__block">
                    <span class="entry__block-title">NÃO entra (e para onde vai)</span>
                    <ul>
                      @for (exclude of entry.excludes; track $index) {
                        <li>{{ formatExclusion(exclude.item, exclude.goesTo) }}</li>
                      }
                    </ul>
                  </div>
                }

                @if (hasTraits(entry)) {
                  <dl class="entry__traits">
                    @if (entry.normalBalance) {
                      <div>
                        <dt>Natureza</dt>
                        <dd>{{ entry.normalBalance }}</dd>
                      </div>
                    }
                    @if (entry.termCriterion) {
                      <div>
                        <dt>Prazo</dt>
                        <dd>{{ entry.termCriterion }}</dd>
                      </div>
                    }
                    @if (entry.expectedSign) {
                      <div>
                        <dt>Sinal esperado</dt>
                        <dd>{{ entry.expectedSign }}</dd>
                      </div>
                    }
                  </dl>
                }

                @if (entry.pitfalls?.length) {
                  <div class="entry__block entry__block--pitfalls">
                    <span class="entry__block-title">Erros comuns</span>
                    <ul>
                      @for (pitfall of entry.pitfalls; track $index) {
                        <li>{{ pitfall }}</li>
                      }
                    </ul>
                  </div>
                }

                @if (entry.decisions?.length) {
                  <div class="entry__block entry__block--decisions">
                    <span class="entry__block-title">Decisões da casa</span>
                    <ul>
                      @for (decision of entry.decisions; track $index) {
                        <li>{{ decision }}</li>
                      }
                    </ul>
                  </div>
                }

                @if (entry.normativeBasis) {
                  <div class="entry__block">
                    <span class="entry__block-title">Base normativa</span>
                    <p>{{ entry.normativeBasis }}</p>
                  </div>
                }

                @if (entry.indicatorImpact) {
                  <div class="entry__block">
                    <span class="entry__block-title">Indicadores afetados</span>
                    <p>{{ entry.indicatorImpact }}</p>
                  </div>
                }

                @if (entry.openQuestions?.length) {
                  <div class="entry__block">
                    <span class="entry__block-title">Perguntas em aberto</span>
                    <ul>
                      @for (question of entry.openQuestions; track $index) {
                        <li>{{ question }}</li>
                      }
                    </ul>
                  </div>
                }

                @if (canManage()) {
                  <div class="entry__actions">
                    <app-button
                      [label]="'Editar verbete'"
                      [icon]="'pi pi-pencil'"
                      [theme]="'white'"
                      [type]="'button'"
                      [disabled]="locked()"
                      data-testid="dictionary-entry-edit"
                      (sendButtonClick)="editRequested.emit(entry)" />
                  </div>
                }
              </div>
            }
          </article>
        }
      </section>
    }
  }
</div>
